import createAction from '../actionCreator';

const action = createAction('listings');

export const GET_LISTINGS = action('GET_LISTINGS');
export const GET_LISTING_DETAILS = action('GET_LISTING_DETAILS');
export const SAVE_LISTING_MAPPING = action('SAVE_LISTING_MAPPING');
export const DELETE_LISTING_MAPPING = action('DELETE_LISTING_MAPPING');
export const CREATE_MAPPING = action('CREATE_MAPPING');